<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.zencustomers" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a routerLink="..">ZEN Master Sites</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">
				Reports
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="staff">
			<fa-icon [icon]="['fas', 'user']" size="sm"></fa-icon>
			<span class="ms-1">Staff Report</span>
		</button>
		View ZEN Master Sites broken down by account owner or assigned tech rep.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="users">
			<fa-icon [icon]="['fas', 'user']" size="sm"></fa-icon>
			<span class="ms-1">ZEN Master Users</span>
		</button>
		View/search Users from all ZEN Master Sites.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="clusters">
			<fa-icon [icon]="['fas', 'cloud']" size="sm"></fa-icon>
			<span class="ms-1">Broadcaster Clusters</span>
		</button>
		View/search Cloud Based Broadcaster Clusters from all ZEN Master Sites.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="objects">
			<fa-icon [icon]="['fas', 'search']" size="sm"></fa-icon>
			<span class="ms-1">Object Search</span>
		</button>
		Search for Objects (Sources, Channels, Targets) across all ZEN Master Sites by name.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="sources">
			<fa-icon [icon]="['fas', 'search']" size="sm"></fa-icon>
			<span class="ms-1">Sources Search</span>
		</button>
		Search for Sources across all ZEN Master Sites by name.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="channels">
			<fa-icon [icon]="['fas', 'search']" size="sm"></fa-icon>
			<span class="ms-1">Channels Search</span>
		</button>
		Search for Channels across all ZEN Master Sites by name.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" routerLink="targets">
			<fa-icon [icon]="['fas', 'search']" size="sm"></fa-icon>
			<span class="ms-1">Targets Search</span>
		</button>
		Search for Targets across all ZEN Master Sites by name.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" (click)="openReport(false)">
			<fa-icon [icon]="['fas', 'file-excel']" size="sm"></fa-icon>
			<span class="ms-1">Site Report</span>
		</button>
		Creates an Excel spreadsheet.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" (click)="openReport(true)">
			<fa-icon [icon]="['fas', 'file-excel']" size="sm"></fa-icon>
			<span class="ms-1">Site Report+</span>
		</button>
		Creates an Excel spreadsheet with object counts.
	</div>

	<div class="mb-2">
		<button type="button" class="btn btn-outline-secondary me-2" (click)="prepUsersByRole()">
			<fa-icon [icon]="['fas', 'file-excel']" size="sm"></fa-icon>
			<span class="ms-1">Find Users By Role</span>
		</button>
		Creates an Excel spreadsheet with a list of ZEN Master users with a specific role.
	</div>
</div>

<button type="button" id="open-users-by-role-modal" data-bs-toggle="modal" data-bs-target="#users-by-role-modal" hidden="true">
</button>
<div class="modal" id="users-by-role-modal" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Find ZEN Master Users By Role</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-users-by-role-modal">
				</button>
			</div>

			<div class="modal-body">
				<form [formGroup]="userByRoleForm" *ngIf="userByRoleForm">

					<div class="form-group">
						<label for="roleToFind">
							Role
						</label>
						<input type="text" id="roleToFind" formControlName="roleToFind" class="form-control" />
					</div>

					<div class="form-group">
						<label for="zenTypes">
							ZEN Master Type(s) (optional)
						</label>
						<ng-select [items]="zmTypeChoices" bindValue="value" bindLabel="label" id="zenTypes" formControlName="zenTypes"
							[multiple]="true" [closeOnSelect]="false" placeholder="Filter by Type">
						</ng-select>
					</div>

					<div class="form-group">
						Note: rows for ZIXI account team will be included
					</div>

					<div class="p-2 text-center">
						<button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="runUsersByRole()"
							ngbTooltip="Click to run report" [disabled]="!userByRoleForm.valid">
							<fa-icon [icon]="ac.sectionIcons.reports" class="me-1">
							</fa-icon>
							Generate Spreadsheet
						</button>
					</div>
					<div class="cp-form-padding"></div>
				</form>
			</div>
		</div>
	</div>